import React, { useState, useEffect } from 'react';
import { apiUrl } from '../../../base/utils';
import { invokePostService } from '../../../service';
import { useSearchParams } from "react-router-dom";
import WHSLoader from "../../../widgets/loader/spinner";
import { Button, Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import './index.scss';
const AutostructuringFailure = () => {
  const [manuscriptMsg, setManuscriptMsg] = useState<any>(null);
  const [manuscriptData, setManuscriptData] = useState<any>({});
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoader, setLoader] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const feedbackDatas = location.state && location.state.articleid;
console.log(feedbackDatas,"fss")
  const handleUpdateManuscript = async () => {
    try {
      const url = apiUrl.nodeApi.autostructuringFailed;
      setLoader(true);
      const payload = {
        articleid: feedbackDatas
      };
      const response: any = await invokePostService(url, payload, {});
      console.log( "response <><><><>", response.data.data.result);
      setManuscriptData(response.data.data.result[0])
      if (!response.data.data.isSuccess) throw new Error(response.data.data.Error);
      if (response.data.data.isSuccess) {
        setManuscriptMsg("true");
        setLoader(false);
      }
    } catch (error) {
      // console.log(error);
      setManuscriptMsg("false");
      setLoader(false);
    }
  };
  const handleOkClick = () => {
    navigate('/submitarticle');
  };
  useEffect(() => {
    handleUpdateManuscript();
  }, []);

  useEffect(() =>{
    const bodyClassName = process.env.REACT_APP_BODY_CLASS || '';
    // console.log(bodyClassName,"bodyClassName");
    // document.querySelector('body')?.classList.remove('demo-body')
    document.querySelector('body')?.classList.add(bodyClassName);
  },[]);
  return (
    <div className="revokecontainer">
  {isLoader && <WHSLoader />}
  <div className="revokebox rounded-3 border p-4 bg-white shadow-sm">
    <h4 className="maintextrevoke mb-4">Auto-structuring Failure Notification</h4>

    <p className="mb-3">Dear Author,</p>

    <p className="mb-4">
      The auto-structuring process during manuscript submission has encountered a failure for the manuscript
      <span className="fw-semibold"> &lt;{manuscriptData?.name}&gt;</span>.
    </p>

    <div className="mb-4">
      <h6 className="fw-semibold mb-2">Details:</h6>
      <ul className="list-unstyled ms-3">
        <li><strong>Journal name:</strong> {manuscriptData?.journal}</li>
        <li><strong>Author(s):</strong> {manuscriptData?.authorname}</li>
        <li><strong>Author mail ID:</strong> {manuscriptData?.email}</li>
        <li><strong>Article Type:</strong> {manuscriptData?.articletype}</li>
        <li><strong>Reason for failure:</strong> Auto Structuring failed</li>
      </ul>
    </div>

    <p className="mb-4">
      Our support team has received your manuscript. We will provide you the updated manuscript via email within 2 business working days. 
      After receiving the updated manuscript version, please upload the manuscript on PeerEase again. Until you receive the updated version 
      from us, please do not re-upload the failed file.
    </p>

    <p className="mb-5">Thank you for your co-operation.</p>

  </div>
  <Button variant="primary" className="revokebutton" onClick={handleOkClick}>
OK</Button>

</div>

  );
};

export default AutostructuringFailure;
